import React from "react";
import { HexColorInput, HexAlphaColorPicker } from "react-colorful";
import toggleColorPicker from "../../../Functions/toggleColorPicker";
import getFonts from "../../../Functions/config/fonts";

const Result = ({ widget, handleInputChange, setColorsAndPreview }) => {
  const { monthlypayment } = widget.htmlData;

  // Font options for dropdown
  const fontOptions = getFonts().map((font) => ({
    value: font,
    label: font,
  }));

  const handleNumberChange = (e, field) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      handleInputChange({
        target: {
          name: `result-${field}`,
          value: `${value}px`
        }
      });
    }
  };

  return (
    <div className="mjwi-acc-panel-wrapper">
      {/* Text Color */}
      <div className="mjwi-row">
        <div className="mjwi-col50">
          <label>Text Color</label>
        </div>
        <div className="mjwi-col66 mjwi-clr-picker">
          <span
            className="clrPickerVal"
            style={{
              backgroundColor: monthlypayment.result.textColor || "#333333",
            }}
            onClick={toggleColorPicker}
          ></span>
          <HexAlphaColorPicker
            color={monthlypayment.result.textColor || "#333333"}
            onChange={(color) =>
              setColorsAndPreview("result", "textColor", color)
            }
            className="mjwi-apfl-color-picker"
          />
          <HexColorInput
            color={monthlypayment.result.textColor || "#333333"}
            onChange={(color) =>
              setColorsAndPreview("result", "textColor", color)
            }
          />
        </div>
      </div>

      {/* Font Family */}
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Font Family</label>
        </div>
        <div className="mjwi-col66">
          <select
            name="result-fontFamily"
            value={monthlypayment.result.fontFamily || "Helvetica Neue"}
            onChange={handleInputChange}
            className="mjwi-input"
          >
            {fontOptions.map((font) => (
              <option key={font.value} value={font.value}>
                {font.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Font Size */}
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Font Size (px)</label>
        </div>
        <div className="mjwi-col66">
          <input
            type="number"
            name="result-fontSize"
            value={parseFloat(monthlypayment.result.fontSize) || 18}
            onChange={(e) => handleNumberChange(e, 'fontSize')}
            className="mjwi-input"
          />
        </div>
      </div>

      {/* Font Weight */}
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Font Weight</label>
        </div>
        <div className="mjwi-col66">
          <select
            name="result-fontWeight"
            value={monthlypayment.result.fontWeight || "normal"}
            onChange={handleInputChange}
            className="mjwi-input"
          >
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="300">300</option>
            <option value="400">400</option>
            <option value="500">500</option>
            <option value="600">600</option>
            <option value="700">700</option>
            <option value="800">800</option>
            <option value="900">900</option>
          </select>
        </div>
      </div>

      {/* Text Align */}
      <div className="mjwi-row">
        <div className="mjwi-col66">
          <label>Text Alignment</label>
        </div>
        <div className="mjwi-col66">
          <select
            name="result-textAlign"
            value={monthlypayment.result.textAlign || "left"}
            onChange={handleInputChange}
            className="mjwi-input"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Result;